import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

function authHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function listAllProductsSimple() {
  const res = await API.get('/admin/products/simple', {
    headers: authHeader(),
  });
  return res.data;
}

export async function listProducts() {
  const res = await API.get('/admin/products', {
    headers: authHeader(),
  });
  return res.data;
}
export async function getProductById(id) {
  const res = await API.get(`/admin/products/${id}`, {
    headers: authHeader(),
  });
  return res.data;
}
